import { useQuery } from 'hooks/useCustomQuery';
import { getAllWholesalerServiceProfiles } from 'API/ServiceProfiles/getAllServiceProfiles';

const useGetAllWholesalerServiceProfiles = ({ enabled = true } = {}) => {
    return useQuery({
        queryKey: ['serviceProfiles', 'wholesaler', 'all'],
        queryFn: () => getAllWholesalerServiceProfiles(),
        refetchOnWindowFocus: false,
        staleTime: 0,
        enabled,
        select: (res) => res.data,
    });
};

export default useGetAllWholesalerServiceProfiles;
